'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _pacomo = require('utils/pacomo');

var _forms = require('metadata/forms');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CompletedByTag = function CompletedByTag(_ref) {
    var requirement = _ref.requirement;

    if (requirement.status === 'COMPLETE') {
        var modifyingUser = requirement.last_modified.name;
        var profileType = requirement.last_modified.user_type;
        var depServiceId = requirement.services[0].id;

        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
                'a',
                { 'data-tip': true, 'data-for': "tooltip-" + requirement.code + depServiceId },
                _react2.default.createElement(_components2.IconCompleted, null)
            ),
            _react2.default.createElement(
                _reactTooltip2.default,
                { id: "tooltip-" + requirement.code + depServiceId, type: 'dark', place: 'left' },
                _react2.default.createElement(
                    'span',
                    { className: 'completed-by' },
                    _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'completedByTag.completedBy',
                        defaultMessage: 'Completed By' })
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'modified-by' },
                    profileType === 'agents' && _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'completedByTag.agentProfile',
                        defaultMessage: 'Agent' }),
                    profileType === 'staff_profiles' && _react2.default.createElement(_reactIntl.FormattedMessage, {
                        id: 'completedByTag.staffProfile',
                        defaultMessage: 'Staff' }),
                    profileType === 'customers' && modifyingUser
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'date-by' },
                    requirement.last_modified.date && _react2.default.createElement(_reactIntl.FormattedRelative, { value: requirement.last_modified.date })
                )
            )
        );
    } else {
        return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components2.IconIncomplete, null)
        );
    }
};

CompletedByTag.propTypes = {
    requirement: _propTypes2.default.object.isRequired
};

exports.default = (0, _pacomo.pacomoTransformer)(CompletedByTag);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/CompletedByTag.js
// module id = 1312
// module chunks = 0